module.exports = __webpack_public_path__ + "media/de_de_s2_Hannah.4c40264b.oga";